<script setup>
const props = defineProps({
  value: {
    type: [Number, String],
    default: 0,
    max: 5
  },
  readonly: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:value'])

</script>

<template>
  <span
    tabindex="0"
    class="flex"
  >
    <svg
      v-for="i in 5"
      :key="i"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      @click="!readonly && emit('update:value', i)"
    >
      <path
        d="M8.00004 2L10.1635 5.93989L14.3404 6.60655L11.0885 9.45356L11.9186 14.0601L8.00004 11.8798L4.08148 14.0601L4.91157 9.45356L1.65967 6.60655L5.83662 5.93989L8.00004 2Z"
        :fill="i <= props.value ? '#569D88' : '#E0E0E0'"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99999 1.3335C8.24328 1.3335 8.46725 1.46603 8.58435 1.67928L10.5907 5.33315L14.4454 5.94838C14.7007 5.98913 14.9094 6.17379 14.981 6.42221C15.0525 6.67063 14.974 6.93802 14.7795 7.10831L11.8115 9.7068L12.5747 13.942C12.6203 14.1956 12.5159 14.4528 12.3063 14.6026C12.0967 14.7524 11.8195 14.7681 11.5944 14.6428L7.99999 12.6429L4.40556 14.6428C4.18043 14.7681 3.90328 14.7524 3.6937 14.6026C3.48412 14.4528 3.37963 14.1956 3.42532 13.942L4.1885 9.7068L1.22047 7.10831C1.02596 6.93802 0.947437 6.67063 1.01898 6.42221C1.09053 6.17379 1.29925 5.98913 1.55454 5.94838L5.40926 5.33315L7.41562 1.67928C7.53272 1.46603 7.7567 1.3335 7.99999 1.3335ZM7.99999 3.38525L6.42092 6.26093C6.32184 6.44138 6.14493 6.56594 5.94163 6.59838L3.16784 7.0411L5.35065 8.95213C5.52677 9.10632 5.60912 9.34158 5.56761 9.57195L4.98711 12.7934L7.67584 11.2974C7.87739 11.1852 8.12258 11.1852 8.32413 11.2974L11.0129 12.7934L10.4324 9.57195C10.3909 9.34158 10.4732 9.10632 10.6493 8.95213L12.8321 7.0411L10.0583 6.59838C9.85504 6.56594 9.67814 6.44138 9.57905 6.26093L7.99999 3.38525Z"
        :fill="i <= props.value ? '#569D88' : '#E0E0E0'"
      />
    </svg>
    <span class="px-1 text-sm">
      <slot />
    </span>
  </span>
</template>

<style scoped>

</style>
